import { createDomain, sample } from 'effector'
import {
  AxiosErrorType,
  Penalty,
  PenaltyCreateFormValues,
  toPenaltyCreateValues,
} from '~/shared/api'
import { pushFx } from '~/shared/lib/history'
import { logger } from '~/shared/lib/logger'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'

export const domain = createDomain('features.penalty.add')

export const createFx = domain.createEffect<
  PenaltyCreateFormValues,
  Penalty,
  AxiosErrorType
>({
  async handler(values) {
    const penalty = new Penalty(toPenaltyCreateValues(values))

    const result = await penalty.save()
    return result.getModel() as Penalty
  },
})

export const formSubmitted = domain.createEvent<PenaltyCreateFormValues>()
sample({
  clock: formSubmitted,
  target: createFx,
})

sample({
  clock: createFx.doneData,
  fn() {
    return {
      message: 'Штраф создан',
      variant: 'success' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: createFx.doneData,
  fn(penalty: Penalty) {
    return `/penalties/${penalty.getApiId()}`
  },
  target: pushFx,
})

sample({
  clock: createFx.failData,
  fn(error) {
    logger.error(error)

    return {
      message: mapMessageErrors(error),
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})
